import { render, staticRenderFns } from "./AddReciever.vue?vue&type=template&id=549d2422&scoped=true"
import script from "./AddReciever.vue?vue&type=script&lang=js"
export * from "./AddReciever.vue?vue&type=script&lang=js"
import style0 from "./AddReciever.vue?vue&type=style&index=0&id=549d2422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d2422",
  null
  
)

export default component.exports